import { render, staticRenderFns } from "./StatisticsAccessByModel.vue?vue&type=template&id=c676cc88&"
import script from "./StatisticsAccessByModel.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports